import React from 'react';

import styles from './GameCanvas.scss';

const GameCanvas = props => {
  const { src, iframeRef, gameLoadingError } = props;
  return (
    <div className="GameCanvas">
      {src && !gameLoadingError ? (
        <iframe
          title="Game player"
          src={src}
          className="GameCanvas__iframe"
          allowFullScreen
          ref={iframeRef}
        />
      ) : null}
    </div>
  );
};

export default GameCanvas;
